import { render, staticRenderFns } from "./maintPro.vue?vue&type=template&id=13d6db89&scoped=true&"
import script from "./maintPro.vue?vue&type=script&lang=js&"
export * from "./maintPro.vue?vue&type=script&lang=js&"
import style0 from "./maintPro.vue?vue&type=style&index=0&id=13d6db89&scoped=true&lang=css&"
import style1 from "./maintPro.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6db89",
  null
  
)

export default component.exports